export const SIGNUP_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdU4lV64esBX4PwzJ0bYAUVLGvlUOeJ9g1rHhBqbi-comKATQ/viewform?usp=publish-editor";
